<template>
  <div>
    <quiz-gender v-if="getCompletedStep == 0"></quiz-gender>
    <quiz-age v-if="getCompletedStep == 1"></quiz-age>
    <quiz-foundational-screen v-if="getCompletedStep == 2"></quiz-foundational-screen>
    <quiz-history v-if="getCompletedStep == 3"></quiz-history>
    <quiz-health-man v-if="getCompletedStep == 4 && getGender == 'male'"></quiz-health-man>
    <quiz-health-woman v-if="getCompletedStep == 4 && getGender == 'female'"></quiz-health-woman>
    <quiz-discuss-man v-if="getCompletedStep == 5 && getGender == 'male'"></quiz-discuss-man>
    <quiz-discuss-woman v-if="getCompletedStep == 5 && getGender == 'female'"></quiz-discuss-woman>
    <quiz-additional-info v-if="getCompletedStep == 6"></quiz-additional-info>
    <quiz-final v-if="getCompletedStep == 7"></quiz-final>
  </div>
</template>

<script>

import QuizGender from "./QuizGender.vue";
import QuizAge from "./QuizAge.vue";
import QuizHistory from "./QuizHistory.vue";
import QuizHealthMan from "./QuizHealthMan.vue";
import QuizHealthWoman from "./QuizHealthWoman.vue";
import QuizDiscussMan from "./QuizDiscussMan.vue";
import QuizDiscussWoman from "./QuizDiscussWoman.vue";
import QuizAdditionalInfo from "./QuizAdditionalInfo.vue";
import QuizFinal from "./QuizFinal.vue";
import QuizFoundationalScreen from "./QuizFoundationalScreen.vue";
import { mapGetters } from "vuex";

export default {
  name: 'QuizBox',
  components: {
    QuizGender,
    QuizAge,
    QuizHistory,
    QuizFoundationalScreen,
    QuizHealthMan,
    QuizHealthWoman,
    QuizDiscussMan,
    QuizDiscussWoman,
    QuizAdditionalInfo,
    QuizFinal,
  },
  computed: {
    ...mapGetters( [
      'getCompletedStep',
      'getGender',
    ] ),
  },

  methods: {}
}
</script>

<style scoped>

h1 {
  text-align: left;
  margin-bottom: 20px;
}

.btn-prev {
  float: left;
}

.btn-next {
  float: right;
  border-color: var(--imc-primary-color);
  background-color: var(--imc-primary-color);
}

ol,
li {
  list-style: none;
  padding: 0;
  margin: 0;
}

ol {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  box-shadow: 2px 2px 4px rgba(170, 170, 170, .5);
}

ol li {
  position: relative;
  padding: 0;
  width: 100%;
  background-color: #fff;
  cursor: pointer;
  transition: all .15s ease-in-out;
  font-size: 18px;
  text-align: left;
}

ol li:hover {
  border-color: var(--imc-primary-color);
}
</style>